import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { ExpertProfile } from "../../../types/expert";
import { logout } from "../auth/authSlice";

interface ExpertState {
  body: ExpertProfile | null;
  updating: boolean;
}

const initialState: ExpertState = {
  body: null,
  updating: false
}

const expertSlice = createSlice({
  name: 'expert',
  initialState,
  reducers: {
    fetchExpert: (state, action) => {
      state.body = null
      state.updating = true
    },
    fetchExpertSuccess: (state, action) => {
      state.body = action.payload
      state.updating = false
    },
    fetchExpertFailed: (state) => {
      state.body = null
      state.updating = false
    },
    createExpert: (state, action) => {
      state.updating = true;
    },
    createExpertSuccess: (state, action) => {
      state.body = action.payload;
      state.updating = false;
    },
    createExpertFailed: (state) => {
      state.body = null;
      state.updating = false;
    },
    updateExpert: (state, action) => {
      state.updating = true
    },
    updateExpertSuccess: (state, action) => {
      state.body = action.payload
      state.updating = false
    },
    updateExpertFailed: (state) => {
      state.body = null
      state.updating = false
    }
  },
  extraReducers(builder) {
    builder.addCase(logout, (state) => {
      state.body = null
      state.updating = false
    })
  }
})

export const {
  fetchExpert,
  fetchExpertSuccess,
  fetchExpertFailed,
  createExpert,
  createExpertSuccess,
  createExpertFailed,
  updateExpert,
  updateExpertSuccess,
  updateExpertFailed
} = expertSlice.actions;

export const selectExpert = (state: RootState) => state.expert
export default expertSlice.reducer